import { usePermissions } from '#composables/usePermissions';
import type { NavigationGuard } from 'vue-router';
import { routes } from '../routes';

export const permissionGuard: NavigationGuard = (to) => {
  const permissions = usePermissions();

  // Check if one of defined permissions is held by the user
  if (to.meta.accessibleIfOneOf?.length) {
    const hasAccess = to.meta.accessibleIfOneOf.some((permission) => permissions[permission].value);

    if (!hasAccess) {
      return { name: routes.performance.name };
    }
  }

  const requiredPermission = to.meta.requiredPermission;

  // Check if a specific user store permission is required
  if (requiredPermission && !permissions[requiredPermission].value) {
    return { name: routes.performance.name };
  }

  // If the user is an admin it does only have access to the admin page,
  // unless they are an organizations creator and the route requires organizations management
  if (
    permissions.isAdmin.value &&
    requiredPermission !== 'isAdmin' &&
    !to.meta.isProjectsAdminRequired &&
    (!permissions.isOrganizationsCreator.value || requiredPermission !== 'isOrganizationsCreator')
  ) {
    return { name: routes.admin.home.name };
  }

  // If the user is an organizations creator it does only have access to the organizations management page,
  // unless they are an admin and the route requires admin
  if (
    permissions.isOrganizationsCreator.value &&
    requiredPermission !== 'isOrganizationsCreator' &&
    !to.meta.isProjectsAdminRequired &&
    (!permissions.isAdmin.value || requiredPermission !== 'isAdmin')
  ) {
    return { name: routes.admin.organizationsManagementList.name };
  }
};
